import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import moment from 'moment'
import { Helmet } from 'react-helmet'
import { Tabs, Tab, Table, Button } from 'react-bootstrap'

const EtlRunnerPage = ({ store }) => {
  if (!store.hasRight(linkConst.LINK_ETL_RUNNER)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const loading = <span>
    <span className='glyphicon glyphicon-refresh glyphicon-refresh-animate' />&nbsp;
    {store.__('Loading...')}
  </span>

  const isProduction = (linkConst.LINK_TO_PRODUCTION).indexOf(window.location.hostname) >= 0
  const runnerStatus = {
    Failed: 'text-danger',
    Finished: 'text-info',
    Running: 'text-success',
    Unknown: 'text-warning'
  }

  const history = (store.cv && store.cv.runnerHistory) || []
  const settings = (store.cv && store.cv.runnerSettings) || []

  const historyTable = (runnerId = null) => {
    const dateF = i => (i ? moment(i).format(defaultConst.DATE_FORMAT_FULL) : '')
    const dateL = ['created_at', 'updated_at', 'finished_at']
    const hide = ['id', 'runner_id']

    const historyItems = runnerId && history.length > 0 && history
      .filter(i => i.runner_id === runnerId)
      .sort((a, b) => b.id > a.id ? 1 : -1)

    return (
      <div>
        <br /><h5><strong>{store.__('History')}</strong></h5>
        {historyItems && historyItems.length > 0
          ? <Table striped bordered condensed hover responsive>
            <thead><tr>
              {historyItems[0] && Object.keys(historyItems[0])
                .filter(i => !hide.includes(i))
                .map(i => <th key={i}>{i.replace('_', ' ')}</th>)}
            </tr></thead>
            <tbody>
              {historyItems
                .filter(i => i.runner_id === runnerId)
                .map(i => <tr key={i} className={runnerStatus[i.status] || runnerStatus.Unknown}>{
                  Object.keys(i)
                    .filter(j => !hide.includes(j))
                    .map(j => <td key={j}>{dateL.includes(j) ? dateF(i[j]) : i[j]}</td>)
                }</tr>)}
            </tbody>
          </Table>
          : <em>- {store.__('Not running yet')} -</em>
        }
      </div>)
  }

  const renderTabs = _ => {
    return (<Tabs>
      {settings
        .filter(i => i.canceled <= 0)
        .sort((a, b) => a.order > b.order ? 1 : -1)
        .map((i, j) => {
          const isDisabled = !isProduction && i.production_only > 0
          const isDisabledIcon = 'glyphicon ' + (isDisabled ? 'glyphicon-ban-circle' : 'glyphicon-play')
          const isRunning = store.cv && store.cv.runnerRunning && store.cv.runnerRunning.find(j => j.runner_id === i.id)
          const isWaiting = store.runnerNavStatus !== null && store.runnerNavStatus !== defaultConst.TITLE_FINISHED

          return (<Tab eventKey={j} title={i.title} key={i}>
            <h5><strong>{store.__('Action')}</strong></h5>
            {i.description && <p>{i.description}</p>}
            {isRunning || isWaiting
              ? <Button bsStyle='success' disabled>
                <span className='glyphicon glyphicon-refresh glyphicon-refresh-animate' />&nbsp;
                {store.__(defaultConst.TITLE_RUNNING)}
              </Button>
              : <Button bsStyle={isDisabled ? 'danger' : 'success'} disabled={isDisabled || isWaiting}
                onClick={store.etlStart.bind(store, i.id)}>
                <span className={isDisabledIcon} />&nbsp;
                {store.__(i.button || i.title)}
              </Button>
            }
            {isDisabled &&
              <p className='text-danger' style={{ marginTop: '0.75em' }}>
                {store.__('Restriction! This job can be run on a production environment only.')}
              </p>}
            {historyTable(i.id)}
          </Tab>)
        }
        )}
    </Tabs>)
  }

  return (
    <section>
      <Helmet title={store.__(linkConst.LINK_ETL_RUNNER_TITLE)} />
      <div className='row'>
        <div className='col-lg-12'>
          <h4>{store.cv.title}</h4>
          {store.cv.loading
            ? loading
            : renderTabs()}
        </div>
      </div>
    </section>
  )
}

EtlRunnerPage.propTypes = {
  store: PropTypes.object.isRequired
}

export default inject('store')(observer(EtlRunnerPage))
